import api from '../../axios';

const DeleteConfirmModal = ({ isOpen, onClose, user, refreshUsers }) => {
  if (!user) return null;

  // Handle delete user request
  const handleDelete = async () => {
    try {
      await api.delete(`/users/${user.id}`);
      refreshUsers(); // Refresh users list after deletion
      onClose(); // Close modal
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  return isOpen ? (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full">
        <h2 className="text-xl font-semibold mb-4">Delete User</h2>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete <strong>{user.name}</strong>? This action cannot be undone.
        </p>
        <div className="flex justify-end space-x-3">
          <button 
            type="button" 
            className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            type="button" 
            className="px-4 py-2 text-sm text-white bg-red-600 hover:bg-red-700 rounded-md"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default DeleteConfirmModal;
